import React, { useState, useEffect, useStyles } from "react";
import ReactDOM from "react-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import CoreCard from "./CoreCard";
import DocumentViewer from "../components/DocumentViewer";
function CardDocument(props) {
  const [expand, setExpand] = useState(false);

  return (
    <>
      <DocumentViewer
        fullscreen={props.fullscreen}
        // isSearch
        portlet
        isExternalDocument={props.isExternalDocument}
        noHeader={!props.fullscreen}
        removeSidebars={!props.fullscreen}
        documentId={JSON.parse(props.portlet.parameters).documentId}
      />
    </>
  );
}

export default CoreCard(withTranslation()(CardDocument));
